// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana Process Types
 * Auto-generated input/output schemas for every Rana process tag. Do not edit manually.
 *
 * The version of the OpenAPI document: generated
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { BuildingFloodRiskInput } from "./BuildingFloodRiskInput";
import {
  BuildingFloodRiskInputFromJSON,
  BuildingFloodRiskInputFromJSONTyped,
  BuildingFloodRiskInputToJSON,
  BuildingFloodRiskInputToJSONTyped,
} from "./BuildingFloodRiskInput";
import type { BuildingFloodRiskOutput } from "./BuildingFloodRiskOutput";
import {
  BuildingFloodRiskOutputFromJSON,
  BuildingFloodRiskOutputFromJSONTyped,
  BuildingFloodRiskOutputToJSON,
  BuildingFloodRiskOutputToJSONTyped,
} from "./BuildingFloodRiskOutput";

/**
 *
 * @export
 * @interface BuildingFloodRiskSchema
 */
export interface BuildingFloodRiskSchema {
  /**
   *
   */
  tag: BuildingFloodRiskSchemaTagEnum;
  /**
   *
   */
  inputs: BuildingFloodRiskInput;
  /**
   *
   */
  outputs: BuildingFloodRiskOutput;
}

/**
 * @export
 */
export const BuildingFloodRiskSchemaTagEnum = {
  BuildingFloodRisk: "building_flood_risk",
} as const;
export type BuildingFloodRiskSchemaTagEnum =
  (typeof BuildingFloodRiskSchemaTagEnum)[keyof typeof BuildingFloodRiskSchemaTagEnum];

/**
 * Check if a given object implements the BuildingFloodRiskSchema interface.
 */
export function instanceOfBuildingFloodRiskSchema(value: object): value is BuildingFloodRiskSchema {
  if (!("tag" in value) || value["tag"] === undefined) return false;
  if (value["tag"] !== "building_flood_risk") return false;

  if (!("inputs" in value) || value["inputs"] === undefined) return false;
  if (!("outputs" in value) || value["outputs"] === undefined) return false;
  return true;
}

export function BuildingFloodRiskSchemaFromJSON(json: any): BuildingFloodRiskSchema {
  return BuildingFloodRiskSchemaFromJSONTyped(json, false);
}

export function BuildingFloodRiskSchemaFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): BuildingFloodRiskSchema {
  if (json == null) {
    return json;
  }
  return {
    tag: json["tag"],
    inputs: BuildingFloodRiskInputFromJSON(json["inputs"]),
    outputs: BuildingFloodRiskOutputFromJSON(json["outputs"]),
  };
}

export function BuildingFloodRiskSchemaToJSON(json: any): BuildingFloodRiskSchema {
  return BuildingFloodRiskSchemaToJSONTyped(json, false);
}

export function BuildingFloodRiskSchemaToJSONTyped(
  value?: BuildingFloodRiskSchema | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    tag: value["tag"],
    inputs: BuildingFloodRiskInputToJSON(value["inputs"]),
    outputs: BuildingFloodRiskOutputToJSON(value["outputs"]),
  };
}
